// removed by extract-text-webpack-plugin
module.exports = {"block":"ltA5FbeS3ETcIGmlBCJ4F","image":"bKGaQU9Ims4b1CNueM9fE","icon":"pkbToR0i_oHbC1x_L0-gR","title":"_1K2uaO9-eVfm6yVOlzJP8h","failed":"IJJIDRL5eRkUkpbblpJqO","link":"_3BeKbWDp1opDEpElxBMfND"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WebcamBlock/WebcamBlock.module.scss
// module id = 820
// module chunks = 0